import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

export const HighlightedSearch = styled.span`
  padding-left: 0;
  padding-right: 0;
  background: ${colors.gold200};
`;
